<template>
  <picture-component
    src="https://img.luminarypodcasts.com/v1/podcast/39c7dc13-a2a2-427d-992d-f1a93ca7a9f4/thumbnail/image/s--1xauJz62--/aHR0cHM6Ly9yZXMuY2xvdWRpbmFyeS5jb20vbHVtaW5hcnkvaW1hZ2UvZmV0Y2gvcy0tRFZJVzZ1YXYtLS9oXzUwMCx3XzUwMC9odHRwOi8vaTEuc25kY2RuLmNvbS9hdmF0YXJzLTAwMDQwODkxMDM4MC00azkxOHAtb3JpZ2luYWwuanBn?h=720&w=720&dpr=2"/>
</template>

<script>
import AdaptiveProgressiveImage from '../components/AdaptiveProgressiveImage';
import PictureComponent from '../components/PictureComponent';

export default {
  name: 'FAQ',
  components: {
    AdaptiveProgressiveImage,
    PictureComponent,
  },
};
</script>

<style lang='scss' scoped>

</style>



// WEBPACK FOOTER //
// app/src/pages/FAQ.vue